import { render } from "./CreateBucket.vue?vue&type=template&id=d410e6a2&scoped=true"
import script from "./CreateBucket.vue?vue&type=script&lang=js"
export * from "./CreateBucket.vue?vue&type=script&lang=js"

import "./CreateBucket.vue?vue&type=style&index=0&id=d410e6a2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/cloudstack/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d410e6a2"]])

export default __exports__